import { combineReducers } from 'redux'

import configurationReducer from './configuration/configurationReducer'
import experimentsReducer from './experiments/experimentsReducer'
import groupsReducer from './groups/groupsReducer'
import usersReducer from './users/usersReducer'
import tokenReducer from './token/tokenReducer'
import resultsReducer from './results/resultsReducer'
import peptideBoxPlotReducer from "./peptideBoxPlot/peptideBoxPlotReducer";

export default combineReducers ({
    configuration: configurationReducer,
    experiments: experimentsReducer,
    groups: groupsReducer,
    users: usersReducer,
    token: tokenReducer,
    results: resultsReducer,
    peptideBoxPlot: peptideBoxPlotReducer,
})